import JobPage from "views/JobPage.js";
import JobDetailPage from "views/JobDetailPage.js";
import InvoicePage from "views/InvoicePage.js";
import ReceivedInvoicePage from "views/InvoiceReceivedPage.js";
import JobInvoicePage from "views/JobInvoicePage.js";
import InvoiceJobPage from "views/InvoiceJobPage.js";
import LoginPage from "views/LoginPage.js";
import AirwayBillDetailPage from "views/AirwayBillDetailPage.js";
import JobReportPage from "views/JobReportPage";
import CostReportPage from "views/CostReportPage";
import InvoiceReportPage from "views/InvoiceReportPage";
import MasterDataPage from "views/MasterDataPage";
import PodPdfPage from "views/PodPdfPage";
import InvoicePdfPage from "views/InvoicePdfPage";
import InvoiceEditPage from "views/InvoiceEditPage";
import AirwayBillPdfPage from "views/AirwayBillPdfPage";
import CollectionDeliveryNotePdfPage from "views/CollectionDeliveryNotePdf";
import ExitCertificatePdfPage from "views/ExitCertificatePdfPage";
import RedirectRoot from "views/RedirectRoot";
import WarehousePage from "views/WarehousePage";
import OperationalCostPage from "views/OperationalCostPage";
import WarehouseEditPage from "views/WarehouseEditPage";
import Quotations from "views/Quotations";
import ManageQuote from "views/ManageQuote";
import CreateQuotePdf from "views/CreateQuotePdf";
import CreateCostPdf from "views/CreateCostPdf";
import ShippingTerms from "views/ShippingTerms";

var routes = [
  {
    path: "/",
    name: "",
    icon: "",
    component: RedirectRoot,
    layout: "/",
  },
  {
    path: "job-list",
    name: "Job List",
    icon: "nc-icon nc-delivery-fast",
    component: JobPage,
    layout: "/",
  },
  {
    path: "quotations",
    name: "Quotations",
    icon: "nc-icon nc-delivery-fast",
    component: Quotations,
    layout: "/",
  },
  {
    path: "quotation/create",
    name: "Create Quote",
    icon: "nc-icon nc-delivery-fast",
    component: ManageQuote,
    layout: "/",
  },
  {
    path: "quotation/edit/:id",
    name: "Edit Quote",
    icon: "nc-icon nc-delivery-fast",
    component: ManageQuote,
    layout: "/",
  },
  {
    path: "quotation/pdf/:id",
    name: "Edit Quote",
    icon: "nc-icon nc-delivery-fast",
    component: CreateQuotePdf,
    layout: "/",
  },
  {
    path: "report-cost/pdf",
    name: "Print cost",
    icon: "nc-icon nc-delivery-fast",
    component: CreateCostPdf,
    layout: "/",
  },
  {
    path: "Invoice",
    name: "Invoice",
    icon: "nc-icon nc-paper",
    component: InvoicePage,
    layout: "/",
  },
   {
    path: "Invoice-received",
    name: "ReceivedInvoice",
    icon: "nc-icon nc-paper",
    component: ReceivedInvoicePage,
    layout: "/",
  },
  {
    path: "job-invoice",  
    name: "JobInvoice",
    icon: "nc-icon nc-paper",
    component: JobInvoicePage,
    layout: "/",
  },
  {
    path: "invoice-job",  
    name: "InvoiceJob",
    icon: "nc-icon nc-paper",
    component: InvoiceJobPage,
    layout: "/",
  },
  {
    path: "invoice-edit/:id",
    name: "Invoice",
    icon: "nc-icon nc-paper",
    component: InvoiceEditPage,
    layout: "/",
  },
  {
    path: "job-report",
    name: "Job Report",
    icon: "nc-icon nc-delivery-fast",
    component: JobReportPage,
    layout: "/",
  },
  {
    path: "cost-report",
    name: "Cost Report",
    icon: "nc-icon nc-delivery-fast",
    component: CostReportPage,
    layout: "/",
  },
  {
    path: "invoice-report",
    name: "Invoice Report",
    icon: "nc-icon nc-delivery-fast",
    component: InvoiceReportPage,
    layout: "/",
  },
  {
    path: "master-data",
    name: "Master Data",
    icon: "nc-icon nc-delivery-fast",
    component: MasterDataPage,
    layout: "/",
  },
  {
    path: "job-details",
    name: "Job Details",
    icon: "nc-icon nc-cart-simple",
    component: JobDetailPage,
    layout: "/",
    show_sidebar: false,
  },
  {
    path: "airwaybill/:id",
    name: "AirwayBill Details",
    icon: "nc-icon nc-cart-simple",
    component: AirwayBillDetailPage,
    layout: "/",
    show_sidebar: false,
  },
  {
    path: "airwaybill",
    name: "AirwayBill Details",
    icon: "nc-icon nc-cart-simple",
    component: AirwayBillDetailPage,
    layout: "/",
    show_sidebar: false,
  },
  {
    path: "invoice-pdf/:id",    
    component: InvoicePdfPage,
    layout: "/",
    display: 'none',
  },
  {
    path: "/Login",
    component: LoginPage,
    layout: "/auth",
    show_sidebar: false,
  },
  {
    path: "podpdf",    
    component: PodPdfPage,
    layout: "/",
    display: 'none',
  },
  {
    path: "airwaybill-pdf/:id",    
    component: AirwayBillPdfPage,
    layout: "/",
    display: 'none',
  },  
  {
    path: "exitcertificate-pdf/:id",    
    component: ExitCertificatePdfPage,
    layout: "/",
    display: 'none',
  },
  {
    path: "collection-delivery-note-pdf/:id",    
    component: CollectionDeliveryNotePdfPage,
    layout: "/",
    display: 'none',
  },  
  {
    path: "warehouse",
    name: "Job List",
    icon: "nc-icon nc-delivery-fast",
    component: WarehousePage,
    layout: "/",
  },
  {
    path: "warehouse-edit/:id",
    name: "Warehouse",
    icon: "nc-icon nc-paper",
    component: WarehouseEditPage,
    layout: "/",
  },
  {
    path: "operational-cost",
    name: "Job List",
    icon: "nc-icon nc-delivery-fast",
    component: OperationalCostPage,
    layout: "/",
  },
  // {
  //   path: "shipping-terms",
  //   name: "Shipping Terms",
  //   icon: "nc-icon nc-delivery-fast",
  //   component: ShippingTerms,
  //   layout: "/",
  // },
  // {
  //   path: "/icons",
  //   name: "Icons",
  //   icon: "nc-icon nc-diamond",
  //   component: Icons,
  //   layout: "/",
  // }
];
export default routes;
